import { Injectable } from '@angular/core';
import { NgrxHttpClient } from '@library/utils/services/http-service';

@Injectable()
export class HomesServiceVaillant {
  constructor(private http: NgrxHttpClient) {
  }
}
